import { getRequest, putRequest, postRequest, patchRequest, deleteRequest, paginationQuery } from './seviceHelpers';

/**
 * API requests starting with /monitors
 */
export default {
    getById: async (id, include) => getRequest(`/monitors/${id}?include=${include}`),
    getIncidents: async (id, pagination) => getRequest(`/monitors/${id}/incidents${pagination ? `?${paginationQuery(pagination)}` : ''}`),

    pause: async id => putRequest(`/monitors/${id}/pause`),
    resume: async id => putRequest(`/monitors/${id}/resume`),

    test: async attributes => postRequest('/monitors/test', {
        data: { type: 'monitor', attributes },
    }),
    create: async (teamId, monitor) => postRequest(`/teams/${teamId}/monitors`, monitor),
    update: async (id, monitor) => patchRequest(`/monitors/${id}`, monitor),
    delete: async id => deleteRequest(`/monitors/${id}`),

    getAvailability: async (id, params) =>
        getRequest(`/monitors/${id}/availability.csv?precision=${params.precision ? params.precision : 'daily'}&timeFrom=${params.timeFrom ? params.timeFrom : null}&timeTo=${params.timeTo ? params.timeTo : null}`),
};
